module.exports = __webpack_public_path__ + "static/media/takumi_japneese.244c264c.mp3";